import { scaleDiverging, scaleLinear } from 'd3'
import shouldUseWhiteText from '../utils/text-color.ts'

const colors = ['#3661AD', '#ffffff', '#D82129']

export default function applyHeatmap(elementId: string = 'win-prob') {
    const cells = Array.from(
        document.querySelectorAll<HTMLElement>(
            `#${elementId} td[data-situation]`
        )
    )

    const values = cells
        .map((c) => Number(c.textContent))
        .filter((v) => !Number.isNaN(v))

    if (!values.length) return

    let colorScale
    if (elementId.includes('win-prob')) {
        colorScale = scaleDiverging(colors).domain([0, 50, 100])
    } else {
        const min = Math.min(...values)
        const max = Math.max(...values)
        const mid = (min + max) / 2
        colorScale = scaleLinear(colors).domain([min, mid, max])
    }

    cells.forEach((cell) => {
        const cellEl = cell
        const value = Number(cell.textContent)
        if (Number.isNaN(value)) return

        const bg = colorScale(value)
        cellEl.style.backgroundColor = bg
        cellEl.style.color = shouldUseWhiteText(bg) ? '#fff' : '#1a1a1a'
    })
}
